import bg from './locale/bg';
import en from './locale/en';
import es from './locale/es';
import pl from './locale/pl';
import ru from './locale/ru';
import kk from './locale/kk';


export default {
  bg,
  en,
  es,
  pl,
  ru,
  kk,
};
